import { render, staticRenderFns } from "./KnFormAssignTeacherToGroup.vue?vue&type=template&id=176f4e3c"
import script from "./KnFormAssignTeacherToGroup.js?vue&type=script&lang=js&external"
export * from "./KnFormAssignTeacherToGroup.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports